import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import School from './pages/School'
import Seminar from './pages/Seminar'
import Workshop from './pages/Workshop'
import NotFound from './pages/NotFound'
import './App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <div className="page-bg-gradient"></div>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#fff',
              color: '#0f172a',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/school/:id" element={<School />} />
            <Route path="/seminar/:id" element={<Seminar />} />
            <Route path="/workshop/:id" element={<Workshop />} />
            <Route path="/school" element={<Home eventType="school" />} />
            <Route path="/seminar" element={<Home eventType="seminar" />} />
            <Route path="/workshop" element={<Home eventType="workshop" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App

